import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useGetRecentDevelopmentsQuery } from 'app/apis/recent-developments.api';
import {
  useGetIsSubscribedQuery,
  useSubscribeMutation,
  useUnsubscribeMutation,
} from 'app/apis/subscription.api';
import { useAuth } from 'app/auth.ctx';

import RecentDevelopmentsCarousal from './components/recent-development-carousal';


const RecentDevelopments = () => {
  const { lang } = useParams();
  const { isLoading, data: recentDevelopments } = useGetRecentDevelopmentsQuery({ lang });
  const { data: isSubscribed } = useGetIsSubscribedQuery();
  const [subscribe, sr] = useSubscribeMutation();
  const [unsubscribe, usr] = useUnsubscribeMutation();
  const { t } = useTranslation();
  const auth = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const toggleSubscription = function () {

    if (auth.id !== '0') {
      if (isSubscribed !== 1) {
        subscribe().then(function () {
          // $rootScope.user.subscribed = true;
          enqueueSnackbar(t('subsSuccessMessage'), { variant: 'success' });
        }).catch((e) => {
          enqueueSnackbar(t('subsErrorMessage'), { variant: 'error' });
        });
      } else {
        unsubscribe().then(() => {
          // $rootScope.user.subscribed = false;
          enqueueSnackbar(t('unsubsSuccessMessage'), { variant: 'success' });
        }).catch((e) => {
          enqueueSnackbar(t('subsErrorMessage'), { variant: 'error' });
        });
      }
    } else {
      enqueueSnackbar(t('loginRequired'), { variant: 'error' });
    }
  };


  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h2" sx={{ pb: 2 }}>
          {t('Recent developments')}
        </Typography>
        {isLoading && <Skeleton height={200}/>}
        {!isLoading && (
          <RecentDevelopmentsCarousal data={recentDevelopments}/>
        )}
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          <Checkbox checked={isSubscribed === 1} onChange={toggleSubscription}/>
          <Typography variant="openSans12" sx={{ color: '#33414B' }}>
            {t('Inform me about recent developments')}
          </Typography>
        </Stack>

      </Grid>
    </Grid>
  );
};

export default RecentDevelopments;
